var _rect, _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResumeCurrent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#28C76F",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 18V17.1C29 16.5 28.6 16.1 28 16.1C27.4 16.1 27 16.5 27 17.1V18C27 23 23 27 18 27C13 27 9 23 9 18C9 13 13 9 18 9C19.3 9 20.5 9.3 21.7 9.8C22.2 10 22.8 9.8 23 9.3C23.2 8.8 23 8.2 22.5 8C21.1 7.3 19.5 7 18 7C11.9 7 7 11.9 7 18C7 24.1 11.9 29 18 29C24.1 29 29 24.1 29 18ZM28.3 8.3C28.7 7.9 29.3 7.9 29.7 8.3C30.1 8.7 30.1 9.3 29.7 9.7L18.7 20.7C18.5 20.9 18.2 21 18 21C17.8 21 17.5 20.9 17.3 20.7L14.3 17.7C13.9 17.3 13.9 16.7 14.3 16.3C14.7 15.9 15.3 15.9 15.7 16.3L18 18.6L28.3 8.3Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_648_124912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 23,
    height: 22
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 18V17.1C29 16.5 28.6 16.1 28 16.1C27.4 16.1 27 16.5 27 17.1V18C27 23 23 27 18 27C13 27 9 23 9 18C9 13 13 9 18 9C19.3 9 20.5 9.3 21.7 9.8C22.2 10 22.8 9.8 23 9.3C23.2 8.8 23 8.2 22.5 8C21.1 7.3 19.5 7 18 7C11.9 7 7 11.9 7 18C7 24.1 11.9 29 18 29C24.1 29 29 24.1 29 18ZM28.3 8.3C28.7 7.9 29.3 7.9 29.7 8.3C30.1 8.7 30.1 9.3 29.7 9.7L18.7 20.7C18.5 20.9 18.2 21 18 21C17.8 21 17.5 20.9 17.3 20.7L14.3 17.7C13.9 17.3 13.9 16.7 14.3 16.3C14.7 15.9 15.3 15.9 15.7 16.3L18 18.6L28.3 8.3Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_648_124912)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 24,
    height: 24,
    fill: "#20C997"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeCurrent);
export default __webpack_public_path__ + "static/media/resume_current.72ebf70a0559a998d99238cecfad6932.svg";
export { ForwardRef as ReactComponent };